
<template>
  <v-container>
    <v-data-table v-if="all_categories" mobile-breakpoint="900" :items="all_categories" :headers="category_list_header" :loading="loading" :search="search">
      <template v-slot:top>
        <v-row align="center" justify="space-between" class="px-3">
          <v-col cols="12" md="6">
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-center">
            <create-category-dialog></create-category-dialog>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.percent_ref="{ item }">
        {{ item.percent_ref }} %
      </template>
      <template v-slot:item.description="{ item }">
        <div v-if="item.id">
          <v-btn color="primary" x-small dark @click="showDescriptionDialog(item)">ver</v-btn>
          <!-- <show-description-dialog :item="item"></show-description-dialog> -->
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div v-if="item.id">
          <v-btn @click="openEditDialog(item)" color="primary" dark small icon><v-icon>mdi-pencil</v-icon></v-btn>
          <v-btn @click="deleteCategory(item)" color="error" dark small icon><v-icon>mdi-delete</v-icon></v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        Não há dados
      </template>
    </v-data-table>

    <show-description-dialog v-if="description_dialog" :item="category" :dialog="description_dialog" @closeDescriptionDialog="handleCloseDescriptionDialog()"></show-description-dialog>
    <edit-category-dialog v-if="edit_dialog" :category="category" :dialog="edit_dialog" @closeEditDialog="handleCloseEditDialog"></edit-category-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'CategoryList',
  components: {
    CreateCategoryDialog: () => import('../create/CreateCategoryDialog.vue'),
    EditCategoryDialog: () => import('../edit/EditCategoryDialog.vue'),
    ShowDescriptionDialog: () => import('./ShowDescriptionDialog.vue')
  },
  data() {
    return {
      search: '',
      loading: false,
      category_list_header: [
        { text: 'Id', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Código', value: 'code' },
        { text: 'Ref.', value: 'percent_ref' },
        { text: 'Descrição', value: 'description' },
        { text: 'Ações', value: 'actions' }
      ],
      edit_dialog: false,
      edit_category: null,
      category: null,
      description_dialog: false
    }
  },
  mounted () {
    this.getCategories();
  },
  methods: {
    deleteCategory(item) {
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: 'Deseja excluir categoria?',
        icon: 'question'
      }).then(r => {
        if (r.isConfirmed) {
          this.delCategory(item);
        }
      })
    },
    handleCloseEditDialog() {
      this.edit_dialog = false;
      this.category = null;
    },
    openEditDialog(item) {
      this.category = {...item};
      this.edit_dialog = true;
    },
    handleCloseDescriptionDialog() {
      this.description_dialog = false;
      this.category = null;
    },
    showDescriptionDialog(item) {
      this.category = {...item};
      this.description_dialog = true;
    },
    getCategories() {
      this.loading = true;
      this.indexCategories().then(() => {
        this.loading = false;
      });
    },
    ...mapActions({
      indexCategories: 'Category/index',
      delCategory: 'Category/delete'
    })
  },
  computed: {
    ...mapState({
      all_categories: state => state.Category.all_categories
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>